import styled from "styled-components";
import { Variables } from "../../styles/Variables";

export const Modal = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.2);
`;

export const Content = styled.div`
  position: relative;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 12px;
  width: 60%;
  min-height: 350px;
  background-color: ${Variables.colorWhite};
  box-shadow: 5px 5px 5px 4px rgba(0, 0, 0, 0.2);
  border-radius: 20px;
`;

export const Close = styled.div`
  position: absolute;
  top: 15px;
  right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  cursor: pointer;

  :hover {
    opacity: 0.8;
  }
`;

export const AnimationLoading = styled.div`
  position: absolute;
  left: 45%;
  top: 50%;
  display: inline-block;
  align-self: center;
  width: 20px;
  height: 20px;

  & :after {
    content: " ";
    display: block;
    margin: 8px;
    width: 64px;
    height: 64px;
    border: 6px solid ${Variables.colorPrimary};
    border-radius: 50%;
    border-color: ${Variables.colorPrimary} transparent ${Variables.colorPrimary} transparent;
    animation: lds-dual-ring 1.2s linear infinite;
  }

  @keyframes lds-dual-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const ImageIcon = styled.img`
  width: 20%;
  height: 60%;
`;

export const Title = styled.h1`
  margin: 20px 0;
  font-weight: 600;
  text-align: center;
  color: ${Variables.colorBlack};
`;

export const Description = styled.p`
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  color: ${Variables.colorBlack};
`;

export const ContainerInfo = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 70%;
  border-radius: 10px;
  background-color: ${Variables.colorWhite};
`;

export const DivUp = styled.div`
  margin-bottom: 30px;
  width: 100%;
  height: 25%;
`;

export const DivDown = styled.div`
  width: 100%;
  height: 70%;
  overflow-y: auto;
  overflow-x: hidden;

  ::-webkit-scrollbar {
    width: 3px;
    height: 3px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${Variables.colorOrange};
  }
`;

export const ContainerNote = styled.div`
  margin-bottom: 10px;
  padding: 2%;
  width: 95%;
  border-radius: 10px;
  border: 2px solid ${Variables.colorBlack};
`;

export const TextArea = styled.textarea`
  box-sizing: border-box;
  width: 100%;
  height: 45%;
  padding: 5px;
  border: 2px solid #000;
  border-radius: 10px;
`;
